import React, {type FC} from 'react'
import {Button} from 'uikit'
import {useAppDispatch} from 'store'
import type {YesNoModal as YesNoModalType} from 'store/modal/entities'
import {hideModalThunk} from 'store/modal/thunk'
import {ModalWrap} from '../../ModalWrap'
import styles from './YesNoModal.scss'

export const YesNoModal: FC<YesNoModalType['props']> = (props) => {
  const {
    message,
    handleNoClick,
    handleYesClick,
  } = props

  const dispatch = useAppDispatch()
  const handleClose = () => dispatch(hideModalThunk(null))

  const onClickNo = () => {
    handleNoClick?.()
    handleClose()
  }

  const onClickYes = () => {
    handleYesClick?.()
    handleClose()
  }

  return (
    <ModalWrap classes={{modal: styles.wrapper}}>
      <div className={styles.message}>{message}</div>
      <div className={styles.buttons}>
        <Button onClick={onClickYes}>Да</Button>
        <Button onClick={onClickNo}>Нет</Button>
      </div>
    </ModalWrap>
  )
}
